(function () {
  'use strict';

  function getProductHandle(card) {
    var link = card.querySelector('a.grid-product__link[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function productUrl(handle) {
    var root = window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return '/cart/add';
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);

    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(value, theme.settings && theme.settings.moneyFormat);
    }

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(value, theme.settings && theme.settings.moneyFormat);
    }

    return '$' + (value / 100).toFixed(2);
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function setPriceMarkup(card, variant) {
    var meta = card.querySelector('.grid-product__meta');
    if (!meta || !variant) return null;

    var price = card.querySelector('.grid-product__price');
    if (!price) {
      price = document.createElement('div');
      meta.appendChild(price);
    }

    price.className = 'grid-product__price js-grid-variant-price';
    while (price.firstChild) price.removeChild(price.firstChild);

    var priceValue = Number(variant.price || 0);
    var compareValue = Number(variant.compare_at_price || 0);
    var hasCompare = compareValue > priceValue;

    var regularLabel = document.createElement('span');
    regularLabel.className = 'visually-hidden js-grid-regular-label';
    regularLabel.textContent = 'Regular price';
    regularLabel.hidden = !hasCompare;
    price.appendChild(regularLabel);

    var compare = document.createElement('span');
    compare.className = 'grid-product__price--original js-grid-compare-price';
    compare.textContent = hasCompare ? formatMoney(compareValue) : '';
    compare.hidden = !hasCompare;
    price.appendChild(compare);

    if (hasCompare) price.appendChild(document.createTextNode(' '));

    var saleLabel = document.createElement('span');
    saleLabel.className = 'visually-hidden js-grid-sale-label';
    saleLabel.textContent = 'Sale price';
    saleLabel.hidden = !hasCompare;
    price.appendChild(saleLabel);

    var current = document.createElement('span');
    current.className = 'js-grid-current-price';
    current.textContent = formatMoney(priceValue);
    price.appendChild(current);

    return price;
  }

  function addVariantPurchaseControls(card, product) {
    var meta = card.querySelector('.grid-product__meta');
    if (!meta) return;

    var variants = product.variants || [];
    var selected = firstAvailableVariant(product);
    if (!selected) return;

    card.querySelectorAll('.js-recent-variant-control').forEach(function (node) {
      node.remove();
    });

    var price = setPriceMarkup(card, selected);
    if (!price || variants.length < 2) return;

    var picker = document.createElement('div');
    picker.className = 'grid-product__variant-picker js-grid-variant-picker js-recent-variant-control';
    var optionNames = product.options || [];
    picker.setAttribute('aria-label', 'Choose ' + (optionNames.length ? optionNames.join(', ') : 'option'));

    variants.forEach(function (variant) {
      var button = document.createElement('button');
      var selectedVariant = String(variant.id) === String(selected.id);
      var variantPrice = Number(variant.price || 0);
      var variantCompare = Number(variant.compare_at_price || 0);

      button.type = 'button';
      button.className = 'grid-product__variant-button js-grid-variant-button' + (selectedVariant ? ' is-selected' : '');
      button.dataset.variantId = variant.id;
      button.dataset.price = formatMoney(variantPrice);
      button.dataset.comparePrice = variantCompare > variantPrice ? formatMoney(variantCompare) : '';
      button.dataset.saving = '';
      button.setAttribute('aria-pressed', selectedVariant ? 'true' : 'false');
      button.textContent = variant.title || 'Option';

      if (!variant.available) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }

      picker.appendChild(button);
    });

    meta.insertBefore(picker, price);

    var form = document.createElement('form');
    form.method = 'post';
    form.action = cartAddUrl();
    form.className = 'grid-product__variant-form js-grid-variant-form js-recent-variant-control';

    var variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.value = selected.id;
    variantInput.className = 'js-grid-variant-id';
    form.appendChild(variantInput);

    var quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';
    form.appendChild(quantityInput);

    var addButton = document.createElement('button');
    addButton.type = 'submit';
    addButton.name = 'add';
    addButton.className = 'btn btn--secondary btn--small grid-product__add-to-cart js-grid-add-to-cart';
    addButton.innerHTML = '<span>Add to cart</span>';
    if (!selected.available) addButton.disabled = true;
    form.appendChild(addButton);

    var message = document.createElement('div');
    message.className = 'grid-product__variant-message js-grid-variant-message';
    message.setAttribute('aria-live', 'polite');
    form.appendChild(message);

    if (price.nextSibling) {
      meta.insertBefore(form, price.nextSibling);
    } else {
      meta.appendChild(form);
    }

    delete card.dataset.variantPriceSynced;
  }

  function selectRecentlyViewedVariant(button) {
    var card = button.closest('.grid-product');
    if (!card) return;

    card.querySelectorAll('.js-grid-variant-button').forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var variantInput = card.querySelector('.js-grid-variant-id');
    if (variantInput) variantInput.value = button.dataset.variantId;

    var price = card.querySelector('.js-grid-current-price');
    var compare = card.querySelector('.js-grid-compare-price');
    var saving = card.querySelector('.js-grid-saving');
    var regularLabel = card.querySelector('.js-grid-regular-label');
    var saleLabel = card.querySelector('.js-grid-sale-label');

    if (price) price.textContent = button.dataset.price || '';

    var hasCompare = Boolean(button.dataset.comparePrice);
    if (compare) {
      compare.textContent = button.dataset.comparePrice || '';
      compare.hidden = !hasCompare;
    }
    if (regularLabel) regularLabel.hidden = !hasCompare;
    if (saleLabel) saleLabel.hidden = !hasCompare;

    if (saving) {
      var savingValue = button.dataset.saving || '';
      saving.textContent = savingValue ? 'Save ' + savingValue : '';
      saving.hidden = !savingValue;
    }
  }

  function bindVariantClicks(section) {
    if (section.dataset.recentVariantClicksBound === 'true') return;
    section.dataset.recentVariantClicksBound = 'true';

    section.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('.js-grid-variant-button');
      if (!button || !section.contains(button) || button.disabled) return;

      event.preventDefault();
      event.stopPropagation();
      selectRecentlyViewedVariant(button);
    }, true);
  }

  function getImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function sizedImageUrl(url, size) {
    if (window.theme && theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
      return theme.Images.getSizedImageUrl(url, size);
    }
    return url;
  }

  function addSecondImage(card, product) {
    if (card.querySelector('.grid-product__secondary-image')) return;

    var images = product.images || [];
    if (images.length < 2) return;

    var secondUrl = getImageUrl(images[1]);
    if (!secondUrl) return;

    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'grid-product__secondary-image small--hide';

    var image = document.createElement('img');
    image.className = 'lazyloaded';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = '';
    image.src = sizedImageUrl(secondUrl, '540x');

    if (window.theme && theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
      image.srcset = [360, 540, 720, 1000].map(function (width) {
        return sizedImageUrl(secondUrl, width + 'x') + ' ' + width + 'w';
      }).join(', ');
      image.sizes = '(min-width: 769px) 25vw, 50vw';
    }

    wrapper.appendChild(image);
    mask.appendChild(wrapper);
  }

  function enhanceCard(card) {
    if (card.dataset.recentlyViewedEnhanced === 'loading' || card.dataset.recentlyViewedEnhanced === 'true') return;

    var handle = getProductHandle(card);
    if (!handle) return;

    card.dataset.recentlyViewedEnhanced = 'loading';

    fetch(productUrl(handle), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.json();
      })
      .then(function (product) {
        addVariantPurchaseControls(card, product);
        addSecondImage(card, product);
        card.dataset.recentlyViewedEnhanced = 'true';
      })
      .catch(function () {
        delete card.dataset.recentlyViewedEnhanced;
      });
  }

  function enhanceSection(section) {
    section.querySelectorAll('.grid-product').forEach(enhanceCard);
  }

  function activateSection(section) {
    if (section.dataset.recentlyViewedActive === 'true') return;
    section.dataset.recentlyViewedActive = 'true';

    bindVariantClicks(section);
    enhanceSection(section);

    var container = section.querySelector('[id^="RecentlyViewed-"]') || section;
    var observer = new MutationObserver(function (mutations) {
      var contentAdded = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });
      if (contentAdded) enhanceSection(section);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function observeSection(section) {
    if (section.dataset.recentlyViewedObserver === 'true') return;
    section.dataset.recentlyViewedObserver = 'true';

    if (!('IntersectionObserver' in window)) {
      activateSection(section);
      return;
    }

    var viewportObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      viewportObserver.disconnect();
      activateSection(section);
    }, { rootMargin: '900px 0px' });

    viewportObserver.observe(section);
  }

  function initialize(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('[data-section-type="recently-viewed"]')) sections.push(scope);

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-section-type="recently-viewed"]').forEach(function (section) {
        sections.push(section);
      });
    }

    sections.forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
